import React, { createContext, useContext, useState, useEffect } from 'react';
const AuthContext = createContext(null);

const ROLES = {
  // ── Credit approvers ──────────────────────────────────────────────────────
  'hafis.karim@ninjavan.co':           { level: 1, name: 'Hafis',       role: 'approver', region: 'all', maxLimit: 5000,    maxTerm: 30 },
  'iqbal.azmi@ninjavan.co':            { level: 2, name: 'Iqbal',   role: 'approver', region: 'all', maxLimit: 320000,  maxTerm: 45 },
  'kaijun.chong@ninjavan.co':          { level: 3, name: 'Kai Jun',   role: 'approver', region: 'all', maxLimit: 930000,  maxTerm: 45 },
  'mar.thienho@ninjavan.co':           { level: 4, name: 'Desmond',    role: 'approver', region: 'all', maxLimit: 1550000, maxTerm: 60 },
  // ── KYC / Sales Admin ─────────────────────────────────────────────────────
  'kashwini.segal@ninjavan.co':        { level: 0, name: 'Kash',      role: 'kyc',      region: 'all', maxLimit: 0, maxTerm: 0 },
  'ckj54313@gmail.com':                { level: 0, name: 'Kai Jun (Test Sales)', role: 'sales', region: 'South', maxLimit: 0, maxTerm: 0 },
  // ── Sales — Leadership ────────────────────────────────────────────────────
  'dwayne.tung@ninjavan.co':           { level: 0, name: 'Dwayne', role: 'sales', region: 'all', maxLimit: 0, maxTerm: 0 },
  // ── Sales — Central ───────────────────────────────────────────────────────
  'rosvinder.kaur@ninjavan.co':        { level: 0, name: 'Ros', role: 'sales',    region: ['North', 'Central'],    maxLimit: 0, maxTerm: 0 },  'hocklai.lee@ninjavan.co':           { level: 0, name: 'Roy',       role: 'sales',    region: 'Central',    maxLimit: 0, maxTerm: 0 },
  // ── Sales — South ─────────────────────────────────────────────────────────
  'afiq.hadi@ninjavan.co':             { level: 0, name: 'Afiq', role: 'sales',   region: ['East Coast', 'East Coast 1', 'East Coast 2', 'South'], maxLimit: 0, maxTerm: 0 },
  'hazmi.ali@ninjavan.co':             { level: 0, name: 'Hazmi',     role: 'sales',    region: 'South',      maxLimit: 0, maxTerm: 0 },
  // ── Sales — North ─────────────────────────────────────────────────────────
  'syedaizat.fadzil@ninjavan.co':      { level: 0, name: 'Aizat',     role: 'sales',    region: 'North',      maxLimit: 0, maxTerm: 0 },
  // ── Sales — East Coast ────────────────────────────────────────────────────
  'adid.muhammad@ninjavan.co':         { level: 0, name: 'Adid',      role: 'sales',    region: ['East Coast', 'East Coast 2'], maxLimit: 0, maxTerm: 0 },
  'kengsoon.yoon@ninjavan.co':         { level: 0, name: 'Yoon', role: 'sales',    region: ['East Coast', 'East Coast 1'], maxLimit: 0, maxTerm: 0 },
};

// Email → display name lookup (used server-side via query, and for requestor name display)
export const EMAIL_TO_NAME = Object.fromEntries(
  Object.entries(ROLES).map(([email, r]) => [email, r.name])
);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('ninja_credit_user');
    if (saved) {
      try { setUser(JSON.parse(saved)); } catch(e) {}
    }
    setLoading(false);
  }, []);

  function loginWithGoogle(credentialResponse) {
    const payload = JSON.parse(atob(credentialResponse.credential.split('.')[1]));
    const email   = payload.email;



    const roleInfo = ROLES[email];
    if (!roleInfo) {
      return { error: 'Your account is not authorised for this system.' };
    }

    const userData = {
      email,
      name:        payload.name,
      picture:     payload.picture,
      role:        roleInfo.role,
      level:       roleInfo.level,
      region:      roleInfo.region,
      maxLimit:    roleInfo.maxLimit,
      maxTerm:     roleInfo.maxTerm,
      displayName: roleInfo.name,
    };
    setUser(userData);
    localStorage.setItem('ninja_credit_user', JSON.stringify(userData));
    return { success: true, user: userData };
  }

  function logout() {
    setUser(null);
    localStorage.removeItem('ninja_credit_user');
  }

  return (
    <AuthContext.Provider value={{ user, loading, loginWithGoogle, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function regionsOf(user) {
  return Array.isArray(user?.region) ? user.region : [user?.region].filter(Boolean);
}
export function regionLabel(user) {
  const r = regionsOf(user);
  const isEC = x => /^East Coast( \d)?$/.test(x);
  const nums = r.filter(x => isEC(x) && x !== 'East Coast');
  if (!nums.length) return r.join(' / ');
  const ecLabel = nums.length > 1 ? 'East Coast' : nums[0];
  const out = [];
  r.forEach(x => { if (isEC(x)) { if (!out.includes(ecLabel)) out.push(ecLabel); } else out.push(x); });
  return out.join(' / ');
}